import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const getClassificationsState = (state: AppState) => state.classifications;

export const classificationsRequestingSelector = createSelector(getClassificationsState, state => state.requesting);
export const classificationsSelector = createSelector(getClassificationsState, state => state.classifications);
export const classificationsDeleteErrorSelector = createSelector(getClassificationsState, state =>
    state.classifications.items.find(c => c.id === state.deleteErrorClassificationId)
);
